import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import { Button } from 'components'
import SubmarkLogo from 'resources/Logo/submark-logo-4-512.png'

import { getCookie } from 'utils'

const Container = styled.div`
    display: grid;
    grid-template-rows: auto auto auto auto;
    grid-row-gap: 1rem;
    width: 20rem;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 2rem;
`

const iconStyle = {
    // width:'5rem', 
    height: '4rem',
    objectFit:'contain', 
    borderRadius: '5px'
}

const DeeplinkScreen = props => {
    const {} = props
    const user = useSelector(state => state.auth.user)
    const pathName = new URL(window.location['href'])
    const redirectId = pathName.searchParams.get('id')
    // const deepLink = user && redirectId && `com.atomicly:/?uid=${user['uid']}&id=${redirectId}`
    const deepLink = user && redirectId && `com.atomicly:/?userId=${user['uid']}&token=${localStorage.getItem('--atomicly-token')}`
    console.log(deepLink)

    React.useEffect(() => {
        if(user && user['uid'] && redirectId){
            window.location = deepLink
        }
    }, [])

    return (
        <Container>
            <img src={SubmarkLogo} style={iconStyle}/>
            <Title>Log in</Title>
            <div>{`Successfully logged in as ${user && user['email']}`}</div>
            <div>Select "Open atomicly" to return to the desktop app</div>
            <Button text='Return to app' styles={{ backgroundColor: 'var(--focus-color)', margin: 0, width: 'min-content' }} 
                onSelect={() => { window.location = deepLink }}
                />
        </Container>
    )
}

export default DeeplinkScreen